export var props = {
  rewards: {
    type: Array,
    required: false,
    default() {
      return [];
    }
  },
  actKey: {
    type: String,
    required: false,
    default: ''
  },
  rankKey: {
    type: String,
    required: false,
    default: ''
  }
};